<div class="container-fluid">
  <div class="border-bottom py-3 mb-3">
    <h1 class="h2 ms-4"><span class="bi bi-speedometer text-primary"></span> Dashboard</h1>
  </div>

  <app-dashboard-grid></app-dashboard-grid>

</div>
